export const isTerminalTranscriptionStatus = (status: string | undefined): boolean =>
  status === 'completed' || status === 'error';
